import React, { FC, PropsWithChildren, ReactElement, useState } from 'react';

import clsx from 'clsx';

import { ArrowDownImage, ArrowUpImage } from 'assets/icons';
import useTabletCheck from 'hooks/useTabletCheck';

import styles from './Sidebar.module.scss';

export interface SidebarElement {
  name: string;
  onClick: () => {};
}

export interface SidebarProps {
  sidebarElements: SidebarElement[];
  activeElement: string;
  borrowerName?: string;
  borrowerEmail?: string;
  additionalInfo?: ReactElement | null;
}

const Sidebar: FC<SidebarProps> = ({
  sidebarElements,
  activeElement,
  borrowerName,
  borrowerEmail,
  additionalInfo,
  children,
}: PropsWithChildren<SidebarProps>) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isTablet = useTabletCheck();

  const handleMenuClick = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  return !isTablet ? (
    <div className={styles.sidebarContainer}>
      {(borrowerName || borrowerEmail) && (
        <div className={styles.topInformationContainer}>
          <div className={styles.borrowerName}>{borrowerName}</div>
          <div className={styles.borrowerEmail}>{borrowerEmail}</div>
        </div>
      )}

      <div className={styles.elementsContainer}>
        {sidebarElements.map((element) => (
          <div
            key={element.name}
            className={clsx(styles.sidebarElement, activeElement === element.name && styles.sidebarElementActive)}
            onClick={element.onClick}
          >
            {element.name}
          </div>
        ))}
      </div>
      {children}
      {additionalInfo}
    </div>
  ) : (
    <>
      <div className={styles.activationMenuButton} onClick={handleMenuClick}>
        {activeElement}
        {isMenuOpen ? <ArrowUpImage /> : <ArrowDownImage />}
      </div>
      {isMenuOpen && (
        <div className={styles.openMenu}>
          {sidebarElements
            .filter((element) => activeElement !== element.name)
            .map((element) => (
              <div
                key={element.name}
                className={clsx(styles.sidebarElement, activeElement === element.name && styles.sidebarElementActive)}
                onClick={() => {
                  element.onClick();
                  setIsMenuOpen(false);
                }}
              >
                {element.name}
              </div>
            ))}
          {children}
        </div>
      )}
      {additionalInfo}
    </>
  );
};

export default Sidebar;
